import React from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import "./SimpleManuStyle.css"
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    menu: {
        width: '11vw',
        direction: 'rtl',
    },
    sappp: {
        width: '12vw',
        direction: 'rtl',
    },
    menuContainer: {
        marginLeft: '2vw',
        marginRight: '2vw',
    }
}));

export default function SimpleMenu(data) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [buttonText, setButtonText] = React.useState(data.data.menuName);
    const [options] = React.useState(data.data.options);

    const classes = useStyles();

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (chosenCategory) => {
        if (options.some(option => option === chosenCategory)) {
            setButtonText(chosenCategory);
            data.changeMenuCallback(data.data.name, chosenCategory);
        }
        if (chosenCategory === "none") {
            setButtonText(data.data.menuName);
            data.changeMenuCallback(data.data.name, "none");
        }
        setAnchorEl(null);
    };

    return (

        <div className={classes.menuContainer}>
            <Button variant="outlined" aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}
                    className={classes.menu}>
                {buttonText}
            </Button>
            <Menu
                id="simple-menu"
                className={classes.menu}
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}>
                {options.map((option, i) => {
                    return <MenuItem key={i} className={classes.sappp}
                                     onClick={() => handleClose(option)}>{option}</MenuItem>
                })}
                <MenuItem className={classes.sappp} onClick={() => handleClose("none")}>ללא</MenuItem>
            </Menu>
        </div>
    );
}
